import { AllManagerUpdates } from '@/components/strategyDetails-page/tabs/updatesTab/allManagerUpdatesPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const AllManagerUpdatesPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>All Updates</title>
      </Head>
      <AllManagerUpdates />
    </>
  );
};

export default AllManagerUpdatesPage;
